import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import 'react-phone-input-2/lib/style.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./App.css";

// Static imports
import AuthLayout from "./components/layouts/auth-layout";
import FirstLayout from "./components/layouts/first-layout";
import HomeLayout from "./components/layouts/homelayout";
import PublicRoutes from "./hooks/routes/public-routes";
import ProtectedRoutes from "./hooks/routes/protected-routes";
import { ROUTES } from "./hooks/routes/routes-constant";
import { decryptAEStoJSON } from "./utils/utilities";

// Pages
import Login from "./pages/auth/login";
import Register from "./pages/auth/register";
import ForgotPassword from "./pages/auth/forgot-password";
import NewPassword from "./pages/auth/new-password";
import Dashboard from "./pages/dashboard/Dashboard";
import Home from "./pages/home/home";
import Doctor from "./pages/doctor-management/doctor";
import AddDoctor from "./pages/doctor-management/adddoctor";
import Patient from "./pages/patient-management/patient";
import PatientAppointmentsDetail from "./pages/patient-management/patient-appointment-details";
import AvailabilityManagement from "./pages/availability-management/availability";
import AddAvailability from "./pages/availability-management/addAvailability";
import BlockAvailability from "./pages/availability-management/block-availability";
import AppointmentManagement from "./pages/appointment-management/appointment";
import BankManagemnet from "./pages/bank-management/mybank";
import MyContractandBank from "./pages/bank-management/my-contractandbank";
import MyProfile from "./pages/auth/my-profile";
import ChangePassword from "./pages/auth/change-password";
import AddPosting from "./pages/matching-management/add-posting";
import MatchingList from "./pages/matching-management/matching-list";
import JobPostList from "./pages/matching-management/posting-list";
import Payment from "./pages/payment-management/my-payment";
import Role from "./pages/role-management/role";
import AddRole from "./pages/role-management/addrole";
import Staff from "./pages/role-management/staff";
import Addstaff from "./pages/role-management/addstaff";
import AddQuestions from "./pages/doctor-management/add-question";
import Rating from "./pages/rating";
import PrivacyAndPolicy from "./pages/policy/privacyandpolicy";
import TermsAndCondition from "./pages/policy/termsandcondition";
import CancelationPolicy from "./pages/policy/cancellation-policy";
import ReschedulingPolicy from "./pages/policy/rescheduling-policy";
import DoctorSlotsCalendar from "./pages/availability-management/doctor-allavailability-calander";
import PageNotFound from "./pages/pageNotFound";
import PricingPlans from "./pages/subscription-plan";
import PaymentSuccess from "./pages/payment-success";
import VerifyEmailOtp from "./pages/auth/verify-emailotp";
import VerifyEmail from "./pages/auth/email-verify";
import RequestVerification from "./pages/auth/user-request";
import VerifyDelete from "./pages/auth/delete-user";


function App() {
  const [sidebarShow, setSidebarShow] = useState(false);
  const { value } = useSelector((state) => state?.loggedUser);
  const userData = decryptAEStoJSON(value);

  return (
    <>
      <Routes>
        {/* Auth Layout */}

        <Route element={<AuthLayout />}>
          <Route path={ROUTES?.LOGIN} element={<PublicRoutes component={<Login />} />} />
          <Route path={ROUTES?.REGISTER} element={<PublicRoutes component={<Register />} />} />
          <Route path={ROUTES?.FORGOT_PASSWORD} element={<PublicRoutes component={<ForgotPassword />} />} />
          <Route path={ROUTES?.NEW_PASSWORD} element={<PublicRoutes component={<NewPassword />} />} />


        </Route>

        {/* Home Layout */}
        <Route path={ROUTES?.VERIFYEMAIL} element={<VerifyEmail />} />
        <Route path={ROUTES?.REQUESTVERIFY} element={<RequestVerification />} />
        <Route path={ROUTES?.DELETEUSER} element={<VerifyDelete />} />



        <Route element={<HomeLayout />}>

          <Route index path={ROUTES?.INDEX} element={<Home />} />
          <Route path={ROUTES?.PRIVACYPOLICY} element={<PrivacyAndPolicy />} />
          <Route path={ROUTES?.CANCELATIONPOLICY} element={<CancelationPolicy />} />
          <Route path={ROUTES?.RESCHEDULINGPOLICY} element={<ReschedulingPolicy />} />
          <Route path={ROUTES?.TERMSANDCONDITION} element={<TermsAndCondition />} />
        </Route>

        {/* First Layout */}
        <Route element={<FirstLayout sidebarShow={sidebarShow} setSidebarShow={setSidebarShow} />}>
          <Route path={ROUTES?.DASHBOARD} element={<ProtectedRoutes component={<Dashboard setSidebarShow={setSidebarShow} />} moduleCode="dashboard" />} />
          <Route path={ROUTES?.MYPROFILE} element={<ProtectedRoutes component={<MyProfile />} />} />
          <Route path={ROUTES?.CHANGEPASSWORD} element={<ProtectedRoutes component={<ChangePassword />} />} />
          <Route path={ROUTES?.ADDBANKANDCONTRACT} element={<ProtectedRoutes component={<MyContractandBank />} requiredVerifiedStatus={4} />} />

          {(userData?.isVerified === 2 || userData?.isVerified === 3 || userData?.isVerified === 4 || userData?.isVerified === 5) ? null : (
            <>
              <Route path={ROUTES?.DOCTOR} element={<ProtectedRoutes component={<Doctor />} moduleCode="doctor-management" />} />
              <Route path={ROUTES?.ADDDOCTOR} element={<ProtectedRoutes component={<AddDoctor />} moduleCode="doctor-management" />} />
              <Route path={ROUTES?.PATIENT} element={<ProtectedRoutes component={<Patient />} moduleCode="patient-management" />} />
              <Route path={ROUTES?.PATIENTAPPOINTMENTDETAIL} element={<ProtectedRoutes component={<PatientAppointmentsDetail />} moduleCode="patient-management" />} />
              <Route path={ROUTES?.AVAILABILITY} element={<ProtectedRoutes component={<AvailabilityManagement />} moduleCode="availability-management" />} />
              <Route path={ROUTES?.ADDAVAILABILITY} element={<ProtectedRoutes component={<AddAvailability />} moduleCode="availability-management" />} />
              <Route path={ROUTES?.BLOCKAVAILABILITY} element={<ProtectedRoutes component={<BlockAvailability />} moduleCode="availability-management" />} />
              <Route path={ROUTES?.APPOINTMENT} element={<ProtectedRoutes component={<AppointmentManagement />} moduleCode="appointment-management" />} />
              <Route path={ROUTES?.PAYMENT} element={<ProtectedRoutes component={<Payment />} moduleCode="payment-management" />} />
              <Route path={ROUTES?.JOBPOTSLIST} element={<ProtectedRoutes component={<JobPostList />} moduleCode="matching-management" />} />
              <Route path={ROUTES?.JOBMATCHINGLIST} element={<ProtectedRoutes component={<MatchingList />} moduleCode="matching-management" />} />
              <Route path={ROUTES?.ADDJOBPOST} element={<ProtectedRoutes component={<AddPosting />} moduleCode="matching-management" />} />
              <Route path={ROUTES?.MYBANKMANAGEMENT} element={<ProtectedRoutes component={<BankManagemnet />} moduleCode="bank-management" />} />
              <Route path={ROUTES?.ROLE_MANAGEMENT} element={<ProtectedRoutes component={<Role />} moduleCode="role-management" />} />
              <Route path={ROUTES?.ADDROLE} element={<ProtectedRoutes component={<AddRole />} moduleCode="role-management" />} />
              <Route path={ROUTES?.STAFF} element={<ProtectedRoutes component={<Staff />} moduleCode="role-management" />} />
              <Route path={ROUTES?.ADDSTAFF} element={<ProtectedRoutes component={<Addstaff />} moduleCode="role-management" />} />
              <Route path={ROUTES?.AVAILABILITYCALANDER} element={<ProtectedRoutes component={<DoctorSlotsCalendar />} moduleCode="availability-management" />} />
              <Route path={ROUTES?.DOCTORQUESTION} element={<ProtectedRoutes component={<AddQuestions />} moduleCode="doctor-management" />} />
              <Route path={ROUTES?.RATING} element={<ProtectedRoutes component={<Rating />} />} />
              <Route path={ROUTES?.SUBSCRIPTION} element={<ProtectedRoutes component={<PricingPlans />} />} />
              <Route path={ROUTES?.PAYMENTSUCCESS} element={<ProtectedRoutes component={<PaymentSuccess />} />} />


            </>
          )}
        </Route>

        {/* Fallback 404 */}
        <Route path="*" element={<PageNotFound />} />
      </Routes>
      <ToastContainer />
    </>
  );
}

export default App;
